module.exports = __webpack_public_path__ + "img/20.cce28386.jpeg";